import { tokens, BLACK_700 } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getDisabilityInformationStyles = () => {
  var _tokens$spacing = tokens.spacing,
    SPACING_4 = _tokens$spacing.SPACING_4,
    SPACING_16 = _tokens$spacing.SPACING_16,
    SPACING_12 = _tokens$spacing.SPACING_12,
    SPACING_20 = _tokens$spacing.SPACING_20;
  return StyleSheet.create({
    radio: {
      flex: 1,
      marginTop: SPACING_4
    },
    uploadFileWidget: {
      marginTop: SPACING_12,
      marginBottom: SPACING_16
    },
    dropdown: {
      marginTop: SPACING_4
    },
    label: {
      marginTop: SPACING_20,
      color: BLACK_700
    }
  });
};